/**
 * Lista curada de zonas horarias principales para el selector de configuración.
 * Subconjunto representativo de Intl.supportedValuesOf('timeZone').
 *
 * @remarks
 * Se actualiza cuando la API libere soporte oficial para timezone en el perfil.
 */
export interface TimezoneOption {
  value: string;
  label: string;
}

export const COMMON_TIMEZONES: TimezoneOption[] = [
  { value: 'Pacific/Honolulu', label: '(UTC-10:00) Honolulu' },
  { value: 'America/Anchorage', label: '(UTC-09:00) Anchorage' },
  { value: 'America/Los_Angeles', label: '(UTC-08:00) Los Ángeles, Seattle' },
  { value: 'America/Denver', label: '(UTC-07:00) Denver, Phoenix' },
  { value: 'America/Chicago', label: '(UTC-06:00) Chicago, Ciudad de México' },
  { value: 'America/Monterrey', label: '(UTC-06:00) Monterrey, Guadalajara' },
  { value: 'America/Bogota', label: '(UTC-05:00) Bogotá, Lima, Quito' },
  { value: 'America/New_York', label: '(UTC-05:00) Nueva York, Miami' },
  { value: 'America/Caracas', label: '(UTC-04:00) Caracas' },
  { value: 'America/Santiago', label: '(UTC-04:00) Santiago' },
  { value: 'America/Sao_Paulo', label: '(UTC-03:00) São Paulo, Buenos Aires' },
  { value: 'America/Argentina/Buenos_Aires', label: '(UTC-03:00) Buenos Aires' },
  { value: 'Atlantic/Azores', label: '(UTC-01:00) Azores' },
  { value: 'Europe/London', label: '(UTC+00:00) Londres, Dublín, Lisboa' },
  { value: 'Africa/Casablanca', label: '(UTC+00:00) Casablanca, Monrovia' },
  { value: 'Europe/Paris', label: '(UTC+01:00) París, Madrid, Roma' },
  { value: 'Europe/Berlin', label: '(UTC+01:00) Berlín, Ámsterdam, Bruselas' },
  { value: 'Africa/Lagos', label: '(UTC+01:00) Lagos, Kinshasa' },
  { value: 'Europe/Helsinki', label: '(UTC+02:00) Helsinki, Kiev, Riga' },
  { value: 'Africa/Cairo', label: '(UTC+02:00) El Cairo, Johannesburgo' },
  { value: 'Asia/Jerusalem', label: '(UTC+02:00) Jerusalén' },
  { value: 'Europe/Moscow', label: '(UTC+03:00) Moscú, San Petersburgo' },
  { value: 'Asia/Riyadh', label: '(UTC+03:00) Riad, Kuwait, Nairobi' },
  { value: 'Asia/Tehran', label: '(UTC+03:30) Teherán' },
  { value: 'Asia/Dubai', label: '(UTC+04:00) Abu Dabi, Muscat' },
  { value: 'Asia/Karachi', label: '(UTC+05:00) Karachi, Islamabad' },
  { value: 'Asia/Kolkata', label: '(UTC+05:30) Chennai, Mumbai, Nueva Delhi' },
  { value: 'Asia/Dhaka', label: '(UTC+06:00) Daca, Almaty' },
  { value: 'Asia/Bangkok', label: '(UTC+07:00) Bangkok, Hanói, Yakarta' },
  { value: 'Asia/Shanghai', label: '(UTC+08:00) Pekín, Shanghái, Hong Kong' },
  { value: 'Asia/Singapore', label: '(UTC+08:00) Singapur, Kuala Lumpur' },
  { value: 'Asia/Tokyo', label: '(UTC+09:00) Tokio, Osaka, Seúl' },
  { value: 'Australia/Sydney', label: '(UTC+10:00) Sídney, Melbourne' },
  { value: 'Pacific/Auckland', label: '(UTC+12:00) Auckland, Wellington' },
];
